import React from 'react';
import PropTypes from 'prop-types';
import TemplateListItem from './TemplateListItem';
import { Spinner, Text } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

const TemplatesList = ({ templates = [], loading, error }) => {
  if (loading && templates.length === 0) {
    return <Spinner accessibilityLabel={translate('common.loading')} isCentered />;
  }

  if (error) {
    return (
      <Text as="p" ccMargin="none none none l">
        {translate('projects.taskList.templates.error')}
      </Text>
    );
  }

  if (!templates.length) {
    return (
      <Text as="p" ccMargin="none none none l">
        {translate('projects.taskList.templates.empty')}
      </Text>
    );
  }

  return templates.map((template) => (
    <TemplateListItem key={template.id} template={template} />
  ));
};

TemplatesList.propTypes = {
  templates: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.bool,
};

export default TemplatesList;
